import '../App.css';
import { Link } from 'react-router-dom';

export default function Resume() {
    return (
        <div className="flex flex-col h-full w-full overflow-x-hidden flex-1">
            <div className="site-heading text-left text-3xl mb-12">
                <Link to="/" className="text-primary rounded px-2 py-1 -ml-2 hover:bg-secondary duration-75">
                    Jenna Permut
                </Link>{' '}
                - Résumé
            </div>

            <div className="flex flex-col mt-16 mb-16">
                <div className="experience-grid">
                    <div className="text-lg whitespace-nowrap">2024 - Present</div>
                    <div className="text-left">
                        <div className="mb-1.5">
                            <div className="font-semibold text-lg">Software Engineer</div>
                        </div>
                        <div className="text-primary font-medium opacity-85">Disney</div>
                    </div>
                </div>

                <div className="experience-grid pt-5">
                    <div className="text-lg">2021 - 2024</div>
                    <div className="text-left">
                        <div className="mb-1.5">
                            <div className="font-semibold text-lg">Associate Software Engineer</div>
                        </div>
                        <div className="text-primary font-medium opacity-85">Disney</div>
                    </div>
                </div>

                <div className="divider"></div>

                <div className="experience-grid">
                    <div className="text-lg">2019</div>
                    <div className="text-left">
                        <div className="font-semibold text-lg">Software Engineering Intern</div>
                        <div className="text-primary font-medium opacity-85">Cortina Productions</div>
                    </div>
                </div>

                <div className="experience-grid pt-5">
                    <div className="text-lg">2018</div>
                    <div className="text-left">
                        <div className="font-semibold text-lg">Software Engineering Intern</div>
                        <div className="text-primary font-medium opacity-85">Hyperspace XR</div>
                    </div>
                </div>

                <div className="experience-grid pt-5">
                    <div className="text-lg">2017</div>
                    <div className="text-left">
                        <div className="font-semibold text-lg">Software Engineering Intern</div>
                        <div className="text-primary font-medium opacity-85">Pyrus</div>
                    </div>
                </div>

            </div>
        </div>
    );
}
